import * as React from 'react';
import {components} from 'react-select';
import {FormLabel, withStyles} from '@material-ui/core';

const CustomControl = React.forwardRef((props: any, _ref) => {
    return (
        <React.Fragment>
            <FormLabel
                className={props?.classes?.label}
            >
                {props?.selectProps?.label}
            </FormLabel>
            <components.Control {...props} />
        </React.Fragment>
    );
});

// @ts-ignore
export const CustomStyledControl: React.FunctionComponent<any> = withStyles({label: {marginBottom: 0, fontSize: '0.75em'}})(CustomControl);